export default __webpack_public_path__ + "static/media/DSC_0512.f6023384.webp";